module.exports = __webpack_public_path__ + "static/media/lighthouse-logo.88abf2ac.jpg";